import React from 'react'

import { RegionSelector } from '@/widgets/RegionSelector'

import { useRegion } from '@/entities/regions'

import { RegionType } from '@/shared/types/deprecated-types'
import Flex from '@/shared/ui/Flex'
import { Margin } from '@/shared/ui/margin'
import { Title } from '@/shared/ui/Typography'

import styles from './ShopsTopPanel.module.scss'

/** Displays the current region and allows the user to change it. */
export const ShopsTopPanel = (): JSX.Element => {
	const { currentRegion } = useRegion()

	return (
		<div className={styles.shopsTopPanel}>
			<Margin>
				<Flex wrap alignEnd>
					<Margin mr="1x">
						<Title level="1">{`Адреса магазинов в ${currentRegion.REGION_P_NAME}`}</Title>
					</Margin>
					<RegionSelector type={RegionType.Shops} />
				</Flex>
			</Margin>
		</div>
	)
}
